import type { ComposeStoreBase } from '@packages/shared/compose-store/types';

const registry = new Map<string, ComposeStoreBase<unknown>[]>();

export function registerFormSideStores(
  formSchemaId: string,
  stores: ComposeStoreBase<unknown>[],
): void {
  registry.set(formSchemaId, stores);
}

export function getFormSideStores(formSchemaId: string | undefined): ComposeStoreBase<unknown>[] {
  if (!formSchemaId) return [];
  return registry.get(formSchemaId) ?? [];
}

/** All side stores registered across forms (used when form schema id is unknown on modal exit). */
export function getAllRegisteredSideStores(): ComposeStoreBase<unknown>[] {
  const seen = new Set<ComposeStoreBase<unknown>>();
  const result: ComposeStoreBase<unknown>[] = [];
  for (const stores of registry.values()) {
    for (const store of stores) {
      if (seen.has(store)) continue;
      seen.add(store);
      result.push(store);
    }
  }
  return result;
}
